import React, { useEffect, useState } from "react";
import { Popover, Tooltip } from "antd";
import { hasPermissions, Permission } from "../constants";
import ProductLabelEditor, { getLabelPopupContainer } from "./ProductLabelEditor";

const EMPTY_LABELS = [];
const PRINT_PILL_STYLE = { display: "inline-block", border: "1px solid #ddd", borderRadius: 10, padding: "2px 8px", margin: "2px 4px 2px 0", fontSize: 12, printColorAdjust: "exact", WebkitPrintColorAdjust: "exact" };
// Matches the inline editor's pills so read-only rows line up with editable ones.
const COMPACT_PILL_STYLE = { display: "inline-flex", alignItems: "center", borderRadius: 10, padding: "2px 8px", fontSize: 11 };
const MORE_STYLE = { background: "#f0f0f0", color: "#EA1E51", border: 0, borderRadius: 10, padding: "2px 6px", fontSize: 11, cursor: "pointer", whiteSpace: "nowrap" };

// maxVisible: show that many labels and a read-only "+N more" list (omit to show all, e.g. invoices).
export default function ProductLabels({ tags = EMPTY_LABELS, productId, screen, editable = false, maxVisible }) {
  const [labels, setLabels] = useState(tags || EMPTY_LABELS);
  useEffect(() => { setLabels(tags || EMPTY_LABELS); }, [tags]);
  useEffect(() => {
    const updated = (event) => {
      if (event.detail.productId === productId) setLabels(event.detail.tags);
    };
    window.addEventListener("product-labels-updated", updated);
    return () => window.removeEventListener("product-labels-updated", updated);
  }, [productId]);
  const visibleLabels = labels.filter((label) => !screen || label.external_details?.[`show_on_${screen}`] === true);
  const canEdit = editable && productId && hasPermissions([Permission.ProductUpdate])[0];
  if (canEdit) return <ProductLabelEditor tags={labels} productId={productId} screen={screen} />;
  if (!visibleLabels.length) return null;
  const pillStyle = maxVisible ? COMPACT_PILL_STYLE : PRINT_PILL_STYLE;
  const renderLabel = (label) => <Tooltip key={label.id} title={label.description}>
    <span style={{ ...pillStyle, color: label.color || "#000", background: label.bg_color || "#fff" }}>{label.value}</span>
  </Tooltip>;
  const shown = maxVisible ? visibleLabels.slice(0, maxVisible) : visibleLabels;
  const overflow = maxVisible ? visibleLabels.slice(maxVisible) : EMPTY_LABELS;
  return <span onClick={(event) => event.stopPropagation()}
    style={maxVisible ? { display: "flex", alignItems: "center", flexWrap: "wrap", gap: 4 } : { display: "block", whiteSpace: "normal" }}>
    {shown.map(renderLabel)}
    {overflow.length > 0 && <Popover trigger="click" placement="bottomLeft" getPopupContainer={getLabelPopupContainer} zIndex={1060}
      content={<div style={{ minWidth: 200, maxHeight: 240, overflowY: "auto" }}>
        {overflow.map((label) => <div key={label.id} style={{ padding: "4px 2px" }}>{renderLabel(label)}</div>)}
      </div>}>
      <button type="button" style={MORE_STYLE}>+{overflow.length} more</button>
    </Popover>}
  </span>;
}
